// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4546 ? "020d8314" : chunkId) + "." + {"3070":"7054e77aa5b7f218","3136":"2af5961812bc22d8","4546":"8380d6b9422eb7ef"}[chunkId] + ".js";
};